export const Menu = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-menu"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M4 8l16 0"></path>
    <path d="M4 16l16 0"></path>
  </svg>
);

// ======================================
export const search = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-search"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"></path>
    <path d="M21 21l-6 -6"></path>
  </svg>
);
// ======================================

export const dashboardIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29"
    height="30"
    viewBox="0 0 29 30"
    fill="none"
  >
    <g clip-path="url(#clip0_394_5458)">
      <path
        d="M11.1015 12.1482C10.0732 11.1198 10.0732 9.45244 11.1015 8.42406L12.28 7.24555C13.3084 6.21717 14.9758 6.21717 16.0041 7.24555C17.0325 8.27393 17.0325 9.94127 16.0041 10.9696L14.8256 12.1482C13.7972 13.1765 12.1299 13.1765 11.1015 12.1482ZM5.79823 16.2729C5.09529 15.57 5.09529 14.4303 5.79823 13.7274C6.50117 13.0244 7.64087 13.0244 8.34381 13.7274L9.52233 14.9059C10.2253 15.6088 10.2253 16.7485 9.52233 17.4515C8.81938 18.1544 7.67969 18.1544 6.97674 17.4515L5.79823 16.2729ZM12.28 22.7548C11.2517 21.7264 11.2517 20.059 12.28 19.0307L13.4586 17.8522C14.4869 16.8238 16.1543 16.8238 17.1826 17.8522C18.211 18.8805 18.211 20.5479 17.1826 21.5763L16.0041 22.7548C14.9758 23.7831 13.3084 23.7831 12.28 22.7548ZM18.7619 12.5489C19.4648 11.8459 20.6045 11.8459 21.3074 12.5489L22.4859 13.7274C23.1889 14.4303 23.1889 15.57 22.4859 16.2729C21.783 16.9759 20.6433 16.9759 19.9404 16.2729L18.7619 15.0944C18.0589 14.3915 18.0589 13.2518 18.7619 12.5489Z"
        stroke="black"
        stroke-width="1.4"
      />
    </g>
    <defs>
      <clipPath id="clip0_394_5458">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(14.1421 0.85791) rotate(45)"
        />
      </clipPath>
    </defs>
  </svg>
);

// ======================================

export const Logo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="63"
    height="38"
    viewBox="0 0 63 38"
    fill="none"
  >
    <g clip-path="url(#clip0_195_6953)">
      <path
        d="M56.7137 31.0448C52.2893 33.3391 47.0783 32.5723 42.2882 32.5723H34.0162L42.1353 24.4611C42.1353 24.4611 45.0135 24.0517 49.1227 24.2564C50.9306 24.3462 53.1688 24.5147 53.4289 22.2251C53.6432 20.3245 52.6518 19.3135 50.7572 19.2962C46.5834 19.2584 42.4033 19.2301 38.2295 19.123C27.1314 18.301 28.364 9.88281 28.364 9.88281H37.2018C37.3752 12.5598 40.5118 12.3913 42.4474 12.4023C48.437 12.4275 56.1415 10.9363 60.309 16.402C63.7436 20.8992 61.7213 28.4451 56.7137 31.0448Z"
        fill="url(#paint0_linear_195_6953)"
      />
      <path
        d="M15.0039 9.88086H23.5344V27.6416L15.0039 36.1621V9.88086Z"
        fill="url(#paint1_linear_195_6953)"
      />
      <path
        d="M27.0225 7.84138H0L7.63989 0.193198L31.1837 0.0625C26.8161 2.8355 27.0683 7.09184 27.0225 7.84138Z"
        fill="url(#paint2_linear_195_6953)"
      />
      <path
        d="M28.6099 7.90486C28.6493 7.18681 29.0481 2.58404 32.7395 0.401542C33.0483 0.220413 33.3997 0.124244 33.7578 0.122824L55.7459 0L48.3377 7.90486H28.6099Z"
        fill="url(#paint3_linear_195_6953)"
      />
      <path
        d="M24.9168 34.835L26.3055 37.9591H25.4685L25.2116 37.3434H23.8103L23.577 37.9607H22.7527L24.0137 34.8365L24.9168 34.835ZM24.983 36.7954L24.4771 35.5814L24.0168 36.7954H24.983Z"
        fill="url(#paint4_linear_195_6953)"
      />
      <path
        d="M31.231 37.006V37.6879C30.8535 37.8928 30.4311 38.001 30.0015 38.0028C29.5166 38.0278 29.041 37.8629 28.676 37.543C28.5182 37.3976 28.3929 37.2208 28.3079 37.0239C28.223 36.827 28.1804 36.6145 28.183 36.4001C28.1855 36.1858 28.2331 35.9743 28.3226 35.7795C28.4121 35.5847 28.5417 35.4108 28.7027 35.2692C29.0786 34.9442 29.5648 34.7751 30.0614 34.7968C30.4572 34.7846 30.8488 34.8799 31.1947 35.0723V35.7683C30.8692 35.572 30.4983 35.4635 30.1182 35.4534C29.8228 35.4406 29.5327 35.5351 29.3017 35.7195C29.2006 35.8016 29.1196 35.9058 29.065 36.0239C29.0103 36.1421 28.9835 36.2712 28.9865 36.4014C28.9838 36.5321 29.0108 36.6618 29.0654 36.7807C29.12 36.8996 29.2008 37.0046 29.3017 37.0879C29.5257 37.273 29.8103 37.3689 30.1008 37.3572C30.2606 37.3585 30.4198 37.3373 30.5737 37.2942C30.8 37.2155 31.0198 37.1192 31.231 37.006Z"
        fill="url(#paint5_linear_195_6953)"
      />
      <path
        d="M35.5136 34.835L36.9023 37.9591H36.0653L35.8068 37.3434H34.4071L34.1738 37.9607H33.3479L34.6089 34.8365L35.5136 34.835ZM35.5798 36.7954L35.0723 35.5814L34.6136 36.7954H35.5798Z"
        fill="url(#paint6_linear_195_6953)"
      />
      <path
        d="M39.0916 34.8347H40.466C40.9276 34.8094 41.3806 34.9667 41.727 35.2724C41.8815 35.4156 42.0036 35.5902 42.0852 35.7843C42.1667 35.9785 42.2058 36.1878 42.1998 36.3983C42.2106 36.6117 42.1737 36.8248 42.092 37.0223C42.0102 37.2197 41.8855 37.3965 41.727 37.54C41.4117 37.8171 40.9636 37.9557 40.3825 37.9557H39.0916V34.8347ZM39.8702 35.4063V37.3856H40.3793C40.514 37.3996 40.6502 37.3839 40.7781 37.3395C40.9061 37.2952 41.0228 37.2233 41.1199 37.129C41.217 37.0347 41.2922 36.9202 41.3402 36.7937C41.3881 36.6672 41.4077 36.5317 41.3975 36.3967C41.4049 36.2642 41.3851 36.1316 41.3393 36.0071C41.2935 35.8825 41.2227 35.7686 41.1312 35.6724C41.0287 35.5792 40.9085 35.5076 40.7776 35.4619C40.6468 35.4161 40.5081 35.3972 40.3699 35.4063H39.8702Z"
        fill="url(#paint7_linear_195_6953)"
      />
      <path
        d="M46.919 37.3859V37.9591H44.613V34.835H46.8875V35.4066H45.3933V36.0632H46.8119V36.6348H45.3933V37.3859H46.919Z"
        fill="url(#paint8_linear_195_6953)"
      />
      <path
        d="M51.0265 35.9923L52.0322 34.835H52.7084V37.9591H51.9297V36.0081L51.0849 36.9875H50.9682L50.1234 36.0081V37.9591H49.3447V34.835H50.0209L51.0265 35.9923Z"
        fill="url(#paint9_linear_195_6953)"
      />
      <path
        d="M56.121 37.9591V36.501L54.8884 34.835H55.8342L56.5119 35.816L57.1928 34.835H58.1386L56.9044 36.5025V37.9591H56.121Z"
        fill="url(#paint10_linear_195_6953)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_195_6953"
        x1="30.4871"
        y1="7.76015"
        x2="55.5118"
        y2="32.8109"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3D155F" />
        <stop offset="1" stopColor="#3D15A9" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_195_6953"
        x1="10.559"
        y1="14.3214"
        x2="23.7012"
        y2="27.4749"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3D155F" />
        <stop offset="1" stopColor="#3D15A9" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_195_6953"
        x1="9.73467"
        y1="-1.90112"
        x2="23.2406"
        y2="11.6196"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3D155F" />
        <stop offset="1" stopColor="#3D15A9" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_195_6953"
        x1="35.52"
        y1="-2.69899"
        x2="47.2214"
        y2="9.01382"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3D155F" />
        <stop offset="1" stopColor="#3D15A9" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_195_6953"
        x1="23.1436"
        y1="35.7058"
        x2="25.8489"
        y2="38.4153"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3D155F" />
        <stop offset="1" stopColor="#3D15A9" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_195_6953"
        x1="28.7957"
        y1="35.1668"
        x2="31.2727"
        y2="37.6462"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3D155F" />
        <stop offset="1" stopColor="#3D15A9" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_195_6953"
        x1="33.7388"
        y1="35.7058"
        x2="36.4457"
        y2="38.4153"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3D155F" />
        <stop offset="1" stopColor="#3D15A9" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_195_6953"
        x1="38.8614"
        y1="35.0646"
        x2="41.5336"
        y2="37.7394"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3D155F" />
        <stop offset="1" stopColor="#3D15A9" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_195_6953"
        x1="44.4002"
        y1="35.0475"
        x2="47.1134"
        y2="37.7634"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3D155F" />
        <stop offset="1" stopColor="#3D15A9" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_195_6953"
        x1="49.4078"
        y1="34.7751"
        x2="52.6484"
        y2="38.0205"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3D155F" />
        <stop offset="1" stopColor="#3D15A9" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_195_6953"
        x1="55.2257"
        y1="34.498"
        x2="57.7925"
        y2="37.0672"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3D155F" />
        <stop offset="1" stopColor="#3D15A9" />
      </linearGradient>
      <clipPath id="clip0_195_6953">
        <rect width="62.016" height="38" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// ==================
export const UserIcon = (
  <svg
    width="35"
    height="38"
    viewBox="0 0 35 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="COCO/Line/User-plus">
      <g id="Vector">
        <path
          d="M4.4668 29.9186C4.4668 26.2588 6.91849 23.1414 10.2504 22.5646L10.5505 22.5126C13.2186 22.0508 15.9372 22.0508 18.6053 22.5126L18.9054 22.5646C22.2373 23.1414 24.689 26.2588 24.689 29.9186C24.689 31.5005 23.5068 32.7829 22.0484 32.7829H7.10743C5.64905 32.7829 4.4668 31.5005 4.4668 29.9186Z"
          stroke="#3D15A9"
          stroke-width="1.5"
        />
        <path
          d="M20.4761 11.4548C20.4761 14.753 17.8354 17.4267 14.5779 17.4267C11.3205 17.4267 8.67979 14.753 8.67979 11.4548C8.67979 8.15661 11.3205 5.48291 14.5779 5.48291C17.8354 5.48291 20.4761 8.15661 20.4761 11.4548Z"
          stroke="#3D15A9"
          stroke-width="1.5"
        />
      </g>
    </g>
  </svg>
);

// ======================

export const AngelDown = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="7"
    viewBox="0 0 13 7"
    fill="none"
  >
    <path
      d="M11.3144 1.04125L6.1726 5.68934L1.03076 1.06882"
      stroke="#5843BE"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
// ==============================

export const StudentIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="21"
    viewBox="0 0 17 21"
    fill="none"
  >
    <g clip-path="url(#clip0_195_9237)">
      <path
        d="M2.19159 10.8772L3.04145 11.1817C4.81176 11.8198 6.58113 12.459 8.34956 13.0996C8.44841 13.1382 8.55805 13.1382 8.65689 13.0996C10.6689 12.3704 12.6816 11.6444 14.6949 10.9215C14.7315 10.9083 14.7689 10.897 14.8233 10.88V11.0243C14.8233 12.4895 14.8233 13.9548 14.8233 15.42C14.8292 15.4586 14.8209 15.4981 14.8001 15.531C14.7792 15.564 14.7472 15.5882 14.7099 15.5992C14.3856 15.7285 14.0877 15.9168 13.831 16.1545C13.5227 16.4496 13.3841 16.7947 13.5106 17.2238C13.6371 17.6528 13.9303 17.8649 14.3342 17.9658C14.5766 18.0298 14.8322 18.0226 15.0707 17.9451C15.5776 17.781 16.0733 17.5962 16.4921 17.2511C16.8959 16.9192 17.0543 16.5034 16.9821 15.9754C16.7226 13.9953 16.0283 12.1576 15.1175 10.3972C14.6968 9.58353 13.9987 9.08758 13.162 8.76983C12.4764 8.52671 11.7652 8.36439 11.0425 8.28613C10.737 8.24559 10.4306 8.22106 10.1252 8.18146C10.0998 8.17275 10.0728 8.16964 10.0461 8.17232C10.0194 8.175 9.9936 8.18342 9.97042 8.19701C9.94723 8.2106 9.92721 8.22904 9.91172 8.25108C9.89623 8.27313 9.88562 8.29825 9.88062 8.32478C9.45053 9.47416 9.01014 10.6198 8.56882 11.7663C8.55008 11.8154 8.52852 11.8606 8.49573 11.9426C8.40203 11.7031 8.31957 11.4901 8.23805 11.2751C7.85763 10.2794 7.47877 9.28338 7.10147 8.28706C7.06961 8.20314 7.03401 8.16638 6.93937 8.17581C5.9677 8.2701 4.99697 8.37852 4.06278 8.68873C3.27476 8.95086 2.56358 9.34876 2.09508 10.0578C1.8285 10.4821 1.59391 10.9258 1.39327 11.3854C0.874537 12.4937 0.4774 13.6556 0.208897 14.8505C0.120819 15.2522 0.0608521 15.6614 0.00463104 16.0687C-0.0731392 16.626 0.187344 17.0305 0.617428 17.3426C1.08455 17.6679 1.61347 17.8926 2.17098 18.0026C2.33081 18.0343 2.49554 18.0314 2.65416 17.9939C2.81277 17.9565 2.96161 17.8854 3.09075 17.7854C3.21988 17.6855 3.32633 17.5589 3.40299 17.4143C3.47964 17.2696 3.52473 17.1102 3.53525 16.9466C3.55493 16.5817 3.36846 16.3016 3.09579 16.098C2.83308 15.9146 2.55995 15.7467 2.27779 15.5954C2.21314 15.5586 2.17566 15.5313 2.17566 15.4483C2.17566 13.9567 2.17566 12.4644 2.17566 10.9715C2.18316 10.9441 2.18784 10.9196 2.19159 10.8772Z"
        fill="black"
      />
      <path
        d="M8.50806 7.75896C9.0185 7.76077 9.52423 7.66058 9.99589 7.46419C10.4676 7.2678 10.8958 6.97912 11.2557 6.6149C11.6156 6.25068 11.9001 5.81817 12.0927 5.34245C12.2852 4.86673 12.3819 4.35727 12.3773 3.84364C12.3726 3.33 12.2667 2.82241 12.0656 2.3503C11.8644 1.87819 11.5722 1.45097 11.2057 1.09341C10.8392 0.735854 10.4059 0.455082 9.93071 0.267374C9.45557 0.0796662 8.94811 -0.0112348 8.43778 -5.78299e-05C6.35202 0.0235144 4.63544 1.78105 4.64668 3.90915C4.65582 4.93354 5.06671 5.91284 5.78989 6.63386C6.51308 7.35488 7.49002 7.75925 8.50806 7.75896Z"
        fill="black"
      />
      <path
        d="M8.77309 20.9999L9.24159 20.8302C10.9344 20.2186 12.6276 19.607 14.3211 18.9954C14.3392 18.9923 14.3565 18.9856 14.3721 18.9757C14.3876 18.9658 14.401 18.9529 14.4115 18.9377C14.422 18.9225 14.4293 18.9053 14.4331 18.8872C14.4369 18.8691 14.437 18.8504 14.4335 18.8323C14.4251 18.7031 14.4335 18.573 14.4335 18.4315L14.2002 18.374C13.5049 18.1958 13.0758 17.6763 13.0393 16.9597C13.0186 16.5165 13.2192 16.1629 13.5246 15.8631C13.7626 15.6325 14.0356 15.4416 14.3333 15.2974C14.3581 15.2834 14.3794 15.2639 14.3957 15.2404C14.4119 15.2168 14.4226 15.1899 14.427 15.1616C14.4313 13.9396 14.4313 12.7173 14.427 11.4947C14.4249 11.4769 14.4218 11.4593 14.4176 11.4419C14.386 11.4482 14.3547 11.4561 14.3239 11.4655C12.5123 12.1179 10.7008 12.7704 8.88928 13.4229C8.84926 13.4305 8.81372 13.4534 8.79014 13.4868C8.76655 13.5202 8.75674 13.5615 8.76278 13.6021C8.76278 16.0334 8.76278 18.4648 8.76278 20.8962C8.76466 20.9226 8.76934 20.9509 8.77309 20.9999Z"
        fill="black"
      />
      <path
        d="M8.23426 20.9991C8.23426 20.9519 8.24175 20.9208 8.24175 20.8907C8.24175 18.4687 8.24175 16.0464 8.24175 13.6238C8.24962 13.5747 8.23788 13.5245 8.2091 13.484C8.18032 13.4436 8.13682 13.4162 8.08809 13.4079C6.29342 12.7648 4.49937 12.1186 2.70595 11.4693C2.66941 11.4561 2.63193 11.4467 2.5804 11.4307C2.5804 11.4835 2.57384 11.525 2.57384 11.5608C2.57384 12.7432 2.57384 13.9246 2.57384 15.107C2.56929 15.1504 2.57926 15.1941 2.60217 15.2311C2.62509 15.2682 2.65963 15.2965 2.70033 15.3116C3.05931 15.4853 3.37988 15.73 3.64295 16.031C4.28386 16.7853 3.92968 17.9526 3.06014 18.2939C2.93486 18.3401 2.80648 18.3773 2.67597 18.4052C2.60195 18.4222 2.57009 18.4505 2.57571 18.5306C2.58414 18.6692 2.53636 18.838 2.60007 18.9379C2.66379 19.0379 2.82964 19.0511 2.95426 19.0963C3.89126 19.4329 4.83388 19.7667 5.77276 20.1052C6.54766 20.3881 7.32068 20.671 8.09464 20.9538L8.23426 20.9991Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_195_9237">
        <rect
          width="17"
          height="21"
          fill="white"
          transform="matrix(-1 0 0 1 17 0)"
        />
      </clipPath>
    </defs>
  </svg>
);
// =============
export const EmailIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-mail-filled"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path
      d="M22 7.535v9.465a3 3 0 0 1 -2.824 2.995l-.176 .005h-14a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-9.465l9.445 6.297l.116 .066a1 1 0 0 0 .878 0l.116 -.066l9.445 -6.297z"
      stroke-width="0"
      fill="currentColor"
    ></path>
    <path
      d="M19 4c1.08 0 2.027 .57 2.555 1.427l-9.555 6.37l-9.555 -6.37a2.999 2.999 0 0 1 2.354 -1.42l.201 -.007h14z"
      stroke-width="0"
      fill="currentColor"
    ></path>
  </svg>
);

// ======================

export const PasswordIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-lock"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6z"></path>
    <path d="M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"></path>
    <path d="M8 11v-4a4 4 0 1 1 8 0v4"></path>
  </svg>
);

// ================

export const PasswordShow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-eye"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"></path>
    <path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6"></path>
  </svg>
);
// ===========================
export const PasswordHide = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-eye-off"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M10.585 10.587a2 2 0 0 0 2.829 2.828"></path>
    <path d="M16.681 16.673a8.717 8.717 0 0 1 -4.681 1.327c-3.6 0 -6.6 -2 -9 -6c1.272 -2.12 2.712 -3.678 4.32 -4.674m2.86 -1.146a9.055 9.055 0 0 1 1.82 -.18c3.6 0 6.6 2 9 6c-.666 1.11 -1.379 2.067 -2.138 2.87"></path>
    <path d="M3 3l18 18"></path>
  </svg>
);
// =================================
export const LoginIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-login-2"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M9 8v-2a2 2 0 0 1 2 -2h7a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-2"></path>
    <path d="M3 12h13l-3 -3"></path>
    <path d="M13 15l3 -3"></path>
  </svg>
);
// ======================
export const AngleUp = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-sort-ascending"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M4 6l7 0" />
    <path d="M4 12l7 0" />
    <path d="M4 18l9 0" />
    <path d="M15 9l3 -3l3 3" />
    <path d="M18 6l0 12" />
  </svg>
);
//  ==============

export const AngleDown = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-sort-descending"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M4 6l9 0" />
    <path d="M4 12l7 0" />
    <path d="M4 18l7 0" />
    <path d="M15 15l3 3l3 -3" />
    <path d="M18 6l0 12" />
  </svg>
);

// ===================
export const ChevUp = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-chevron-up"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M6 15l6 -6l6 6"></path>
  </svg>
);

//  ==========================
export const ChevDown = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-chevron-down"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M6 9l6 6l6 -6"></path>
  </svg>
);
// =========================
export const arrowLeft = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-chevrons-left"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M11 7l-5 5l5 5"></path>
    <path d="M17 7l-5 5l5 5"></path>
  </svg>
);
// ========================
export const arrowRight = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-chevrons-right"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M7 7l5 5l-5 5"></path>
    <path d="M13 7l5 5l-5 5"></path>
  </svg>
);

// ==================================
export const chevronLeft = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-chevron-left"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M15 6l-6 6l6 6" />
  </svg>
);

// ==================================
export const chevronRight = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-chevron-right"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M9 6l6 6l-6 6" />
  </svg>
);

// ============================

export const Logout = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-logout-2"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M10 8v-2a2 2 0 0 1 2 -2h7a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-2"></path>
    <path d="M15 12h-12l3 -3"></path>
    <path d="M6 15l-3 -3"></path>
  </svg>
);
// ============================

export const UnivIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-school"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M22 9l-10 -4l-10 4l10 4l10 -4v6"></path>
    <path d="M6 10.6v5.4a6 3 0 0 0 12 0v-5.4"></path>
  </svg>
);
// ============================

export const SubjIcons = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-math"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M19 5h-7l-4 14l-3 -6h-2"></path>
    <path d="M14 13l6 6"></path>
    <path d="M14 19l6 -6"></path>
  </svg>
);
// ===================
export const addition = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-apps"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M4 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path>
    <path d="M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path>
    <path d="M14 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path>
    <path d="M14 7l6 0"></path>
    <path d="M17 4l0 6"></path>
  </svg>
);
// ===================
export const pdf = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-file-type-pdf"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M14 3v4a1 1 0 0 0 1 1h4"></path>
    <path d="M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4"></path>
    <path d="M5 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6"></path>
    <path d="M17 18h2"></path>
    <path d="M20 15h-3v6"></path>
    <path d="M11 15v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z"></path>
  </svg>
);
// ===========

export const video = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-badge-vo"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"></path>
    <path d="M7 9l2 6l2 -6"></path>
    <path d="M15.5 9a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1 -3 0v-3a1.5 1.5 0 0 1 1.5 -1.5z"></path>
  </svg>
);
// ==================
export const PhoneList = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-list-numbers"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M11 6h9"></path>
    <path d="M11 12h9"></path>
    <path d="M12 18h8"></path>
    <path d="M4 16a2 2 0 1 1 4 0c0 .591 -.5 1 -1 1.5l-3 2.5h4"></path>
    <path d="M6 10v-6l-2 2"></path>
  </svg>
);

// ====================

export const AudioIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-headphones"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M4 13m0 2a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-1a2 2 0 0 1 -2 -2z"></path>
    <path d="M15 13m0 2a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-1a2 2 0 0 1 -2 -2z"></path>
    <path d="M4 15v-3a8 8 0 0 1 16 0v3"></path>
  </svg>
);
// ====================

export const UpArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-arrow-big-up-lines"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M9 12h-3.586a1 1 0 0 1 -.707 -1.707l6.586 -6.586a1 1 0 0 1 1.414 0l6.586 6.586a1 1 0 0 1 -.707 1.707h-3.586v3h-6v-3z"></path>
    <path d="M9 21h6"></path>
    <path d="M9 18h6"></path>
  </svg>
);
//  ==============

export const DownArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-arrow-big-down-lines"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M15 12h3.586a1 1 0 0 1 .707 1.707l-6.586 6.586a1 1 0 0 1 -1.414 0l-6.586 -6.586a1 1 0 0 1 .707 -1.707h3.586v-3h6v3z"></path>
    <path d="M15 3h-6"></path>
    <path d="M15 6h-6"></path>
  </svg>
);
// ==================
export const NotificationIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-bell-filled"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path
      d="M14.235 19c.865 0 1.322 1.024 .745 1.668a3.992 3.992 0 0 1 -2.98 1.332a3.992 3.992 0 0 1 -2.98 -1.332c-.552 -.616 -.158 -1.579 .634 -1.661l.11 -.006h4.471z"
      stroke-width="0"
      fill="currentColor"
    />
    <path
      d="M12 2c1.358 0 2.506 .903 2.875 2.141l.046 .171l.008 .043a8.013 8.013 0 0 1 4.024 6.069l.028 .287l.019 .289v2.931l.021 .136a3 3 0 0 0 1.143 1.847l.167 .117l.162 .099c.86 .487 .56 1.766 -.377 1.864l-.116 .006h-16c-1.028 0 -1.387 -1.364 -.493 -1.87a3 3 0 0 0 1.472 -2.063l.021 -.143l.001 -2.97a8 8 0 0 1 3.821 -6.454l.248 -.146l.01 -.043a3.003 3.003 0 0 1 2.562 -2.29l.182 -.017l.176 -.004z"
      stroke-width="0"
      fill="currentColor"
    />
  </svg>
);

// =============================
export const ActionList = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-dots-vertical"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
    <path d="M12 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
    <path d="M12 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
  </svg>
);
// ============================

export const DeleteIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-circle-minus"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
    <path d="M9 12l6 0" />
  </svg>
);
// ============================
export const logs = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-users-group"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M10 13a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
    <path d="M8 21v-1a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v1" />
    <path d="M15 5a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
    <path d="M17 10h2a2 2 0 0 1 2 2v1" />
    <path d="M5 5a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
    <path d="M3 13v-1a2 2 0 0 1 2 -2h2" />
  </svg>
);
export const backIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-arrow-left"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M5 12l14 0" />
    <path d="M5 12l6 6" />
    <path d="M5 12l6 -6" />
  </svg>
);
export const permission = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-user-check"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
    <path d="M6 21v-2a4 4 0 0 1 4 -4h4" />
    <path d="M15 19l2 2l4 -4" />
  </svg>
);

export const dots = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-dots-vertical"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
    <path d="M12 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
    <path d="M12 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
  </svg>
);
export const about = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-info-circle"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
    <path d="M12 9h.01" />
    <path d="M11 12h1v4h1" />
  </svg>
);
export const tmscons = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-heart"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572" />
  </svg>
);
export const alerts = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-alert-triangle-filled"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path
      d="M12 1.67c.955 0 1.845 .467 2.39 1.247l.105 .16l8.114 13.548a2.914 2.914 0 0 1 -2.307 4.363l-.195 .008h-16.225a2.914 2.914 0 0 1 -2.582 -4.2l.099 -.185l8.11 -13.538a2.914 2.914 0 0 1 2.491 -1.403zm.01 13.33l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -7a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z"
      stroke-width="0"
      fill="currentColor"
    />
  </svg>
);
export const add = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-layout-grid-add"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M4 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
    <path d="M14 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
    <path d="M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
    <path d="M14 17h6m-3 -3v6" />
  </svg>
);

//  =====================
export const Info = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-info-square-rounded"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M12 9h.01" />
    <path d="M11 12h1v4h1" />
    <path d="M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z" />
  </svg>
);
// ================
export const Post = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-message-2-share"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M8 9h8" />
    <path d="M8 13h6" />
    <path d="M12 21l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6" />
    <path d="M16 22l5 -5" />
    <path d="M21 21.5v-4.5h-4.5" />
  </svg>
);
// ===============================
export const Duplicate = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-copy"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M7 7m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" />
    <path d="M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1" />
  </svg>
);
// ===============================

export const Settings = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-settings-2"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z" />
    <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
  </svg>
);
// =============================

export const Reasons = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-brand-reason"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z" />
    <path d="M18 18h-3v-6h3" />
    <path d="M18 15h-3" />
    <path d="M8 18v-6h2.5a1.5 1.5 0 0 1 0 3h-2.5" />
    <path d="M12 18l-2 -3" />
  </svg>
);
// =======================================
export const Admins = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-user-cog"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
    <path d="M6 21v-2a4 4 0 0 1 4 -4h2.5" />
    <path d="M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
    <path d="M19.001 15.5v1.5" />
    <path d="M19.001 21v1.5" />
    <path d="M22.032 17.25l-1.299 .75" />
    <path d="M17.27 20l-1.3 .75" />
    <path d="M15.97 17.25l1.3 .75" />
    <path d="M20.733 20l1.3 .75" />
  </svg>
);
export const exitModal = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-x"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    strokeWidth={2}
    stroke="currentColor"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M18 6l-12 12" />
    <path d="M6 6l12 12" />
  </svg>
);

export const eyeOn = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-eye"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    strokeWidth={2}
    stroke="currentColor"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
    <path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" />
  </svg>
);

export const eyeOff = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-eye-off"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    strokeWidth={2}
    stroke="currentColor"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M10.585 10.587a2 2 0 0 0 2.829 2.828" />
    <path d="M16.681 16.673a8.717 8.717 0 0 1 -4.681 1.327c-3.6 0 -6.6 -2 -9 -6c1.272 -2.12 2.712 -3.678 4.32 -4.674m2.86 -1.146a9.055 9.055 0 0 1 1.82 -.18c3.6 0 6.6 2 9 6c-.666 1.11 -1.379 2.067 -2.138 2.87" />
    <path d="M3 3l18 18" />
  </svg>
);

export const edit = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-edit"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    strokeWidth={2}
    stroke="currentColor"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
    <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
    <path d="M16 5l3 3" />
  </svg>
);
export const plus = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-plus"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    strokeWidth={2}
    stroke="currentColor"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M12 5l0 14" />
    <path d="M5 12l14 0" />
  </svg>
);

export const Preview = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-arrow-narrow-left"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M5 12l14 0" />
    <path d="M5 12l4 4" />
    <path d="M5 12l4 -4" />
  </svg>
);
